export function formatDate(iso, lang = "de") {
  if (!iso) return "–";
  try {
    const locale = { de: "de-CH", fr: "fr-CH", it: "it-CH", en: "en-GB" }[lang] || "de-CH";
    return new Date(iso).toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
  } catch (_) {
    return "–";
  }
}

export function formatDateTime(iso, lang = "de") {
  if (!iso) return "–";
  try {
    const locale = { de: "de-CH", fr: "fr-CH", it: "it-CH", en: "en-GB" }[lang] || "de-CH";
    return new Date(iso).toLocaleString(locale, {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch (_) {
    return "–";
  }
}

// Pick a language from a multilingual content object { de, fr, it, en }.
export function pickContent(obj, lang = "de") {
  if (obj == null) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] ?? obj.de ?? obj.en ?? "";
}

export function formatWhen(iso) {
  if (!iso) return "Termin offen";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "Termin offen";
  return d.toLocaleString("de-CH", { weekday: "short", day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
